import { FETCH_RECIPIENTS_SUCCESS } from "../actions/recipients/fetchRecipients"

const initialState = []

export function recipients(state=initialState, { type, payload }) {
  switch(type){
    case FETCH_RECIPIENTS_SUCCESS:
      return payload.map(recipient=>({...recipient, label: recipient.name, value: recipient.id }))
    default:
      return state
  }
}